import { BehaviorSubject } from "rxjs";

export const openDialogConfirmation$ = new BehaviorSubject<boolean>(false);
export const setupDialog$ = new BehaviorSubject<IConfirmationDialog>({
  subtitle: "",
  headerIcon: undefined,
  onlyConfirm: false,
  customButtons: undefined,
  title: "",
  content: "",
  onWhatsapp: "",
  onClose: () => { },
  onNegation: () => { },
  onConfirmation: () => { },
  yesText: "Sim",
  noText: "Não",
  size: "300px",
  maxWidth: "sm",
  submitButtonClassName: '',
  className: '',
});

export interface IConfirmationDialog {
  headerIcon?: JSX.Element;
  subtitle?: React.ReactNode;
  title: React.ReactNode;
  content: React.ReactNode;
  onConfirmation: Function;
  onNegation?: Function;
  onClose: Function;
  yesText?: string;
  onWhatsapp?: string;
  noText?: string;
  size?: string | number | null;
  propagateWhenConfirm?: boolean
  submitButtonClassName?: string;
  className?: string;
  onlyConfirm?: boolean;
  customButtons?: React.ReactNode; 
  maxWidth?: false | "sm" | "xs" | "md" | "lg" | "xl" | undefined;
}

type ConfirmationDialogType = {
  open: () => void,
  close: () => void,
  setup: (params: IConfirmationDialog) => void,
}

const ConfirmationDialog = (): ConfirmationDialogType => {
  let setup: IConfirmationDialog = setupDialog$.getValue();
  return {
    setup: (params: IConfirmationDialog) => {
      const { title, content, noText, size, yesText, onClose, onConfirmation, onNegation, onWhatsapp, subtitle, headerIcon, submitButtonClassName, onlyConfirm, customButtons, maxWidth, className, propagateWhenConfirm = true } = params;

      setup.headerIcon = headerIcon;
      setup.title = title;
      setup.subtitle = subtitle;
      setup.content = "";
      setup.noText = noText;
      setup.size = size;
      setup.yesText = yesText;
      setup.onClose = onClose;
      setup.onClose = onClose;
      setup.onConfirmation = onConfirmation;
      setup.onNegation = onNegation;
      setup.onWhatsapp = onWhatsapp;
      setup.submitButtonClassName = submitButtonClassName;
      setup.propagateWhenConfirm = propagateWhenConfirm;
      setup.onlyConfirm = onlyConfirm;
      setup.customButtons = customButtons;
      setup.maxWidth = maxWidth;
      setup.className = className;

      setupDialog$.next(setup);
      setTimeout(() => {
        setup.content = content;
        setupDialog$.next(setup);
      }, 500)
    },
    close: () => {
      openDialogConfirmation$.next(false);
    },
    open: () => {
      setTimeout(() => {
        openDialogConfirmation$.next(true);
      }, 500)
    },
  }

}

const confirmationDialog = ConfirmationDialog();

export { confirmationDialog };